import Card from "app/components/Card";
import CustomTooltip from "app/components/Tooltip";
import { useQueryState } from "nuqs";
import React from "react";
import ItemAction from "../ItemAction";
import TicketActions from "../TicketActions";
import ColumnCustomize from "../../../Tickets/TicketFields/ColumnCustomize";
import { ITickets, TicketGroup } from "../../../Tickets/types";

interface TicketProps {
  ticket: ITickets;
  isSelected?: boolean;
  onCheckboxClick: (ticket: ITickets) => void;
  group: TicketGroup;
}

export default function TicketCard({
  ticket,
  isSelected,
  onCheckboxClick,
  group,
}: TicketProps) {
  const [, setTid] = useQueryState("tid");
  return (
    <Card
      key={ticket?._id}
      className={`${
        isSelected ? "border-primary !bg-primary50 " : ""
      } rounded-[6px] ps-[10px] pr-[8px] py-[12px] cursor-pointer hover:border-primary hover:border  relative`}
    >
      <div className="flex flex-col gap-[12px] group">
        <div className="flex flex-row gap-[4px] group relative px-[6px] items-center  justify-between ">
          <CustomTooltip
            text={ticket?.ticketName}
            contentClassName="max-w-[443px] !text-xs font-normal text--white"
            className="text-start"
            position="bottom"
          >
            <div
              className="text-xs leading-[15px] font-medium text-black text-wrap line-clamp-2 overflowAnywhere "
              onClick={() => {
                setTid(ticket?._id);
              }}
            >
              {ticket?.ticketName}
            </div>
          </CustomTooltip>
          <ItemAction
            ticketName={ticket?.ticketName}
            ticketId={ticket?._id}
            isSelected={isSelected as boolean}
            onSelectTicket={() => {
              onCheckboxClick(ticket);
            }}
          />
        </div>

        <TicketActions ticket={ticket} status={group.name} />
        <ColumnCustomize ticket={ticket} />
      </div>
    </Card>
  );
}
